module.exports = __webpack_public_path__ + "img/abcdf84.jpg";